import React, {
  useEffect,
  useState,
  useMemo,
  useRef,
  useCallback,
  useContext,
} from "react";
import { AuthContext } from "../../context/AuthContext";
import Grid from "@mui/material/Grid2";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { Box, TextField, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import { useSnackbar } from "notistack";
import PulseLoader from "react-spinners/PulseLoader";
import { useNavigate } from "react-router-dom";
import { getDataWithToken } from "../../services/GetDataService";
import IconButton from "@mui/material/IconButton";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { handlePutData } from "../../services/PutDataService";
import ImageUpload from "../../utils/ImageUpload";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import { bangladeshBankList, depositStatusList } from "../../data";

const UpdateDeposit = ({ clearFilter, row }) => {
  const navigate = useNavigate();
  const { login, unity_fund_admin_panel, logout } = useContext(AuthContext);

  const [addDepositDialog, setAddDepositDialog] = useState(false);
  const [depositDate, setDepositDate] = useState(null);
  const [depositMonth, setDepositMonth] = useState(null);
  const [userId, setUserId] = useState("");
  const [amount, setAmount] = useState("");
  const [bankName, setBankName] = useState("");
  const [transactionNo, setTransactionNo] = useState("");
  const [remarks, setRemarks] = useState("");
  const [depositStatus, setDepositStatus] = useState("pending");
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [userList, setUserList] = useState([]);
  const [file, setFile] = useState(null);
  const { enqueueSnackbar } = useSnackbar();

  const handleDialogClose = (event, reason) => {
    if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
      setAddDepositDialog(false);
      clearForm();
    }
  };

  const handleSnakbarOpen = (msg, vrnt) => {
    let duration;
    if (vrnt === "error") {
      duration = 3000;
    } else {
      duration = 1000;
    }
    enqueueSnackbar(msg, {
      variant: vrnt,
      autoHideDuration: duration,
    });
  };

  const validation = () => {
    let isError = false;

    if (!depositDate) {
      handleSnakbarOpen("Please select deposit date", "error");
      return (isError = true);
    }

    if (!depositMonth) {
      handleSnakbarOpen("Please select deposit month", "error");
      return (isError = true);
    }

    if (!amount || parseFloat(amount) <= 0) {
      handleSnakbarOpen("Please enter valid amount", "error");
      document.getElementById("amount").focus();
      return (isError = true);
    }

    return isError;
  };

  const clearForm = () => {
    setDepositDate(null);
    setDepositMonth(null);
    setUserId("");
    setAmount("");
    setBankName("");
    setTransactionNo("");
    setRemarks("");
    setDepositStatus("");
    setFile(null);
  };

  const onSubmit = async (e) => {
    e.preventDefault();

    if (validation()) {
      return;
    }

    setLoading(true);

    var formdata = new FormData();
    formdata.append("deposit_date", dayjs(depositDate).format("YYYY-MM-DD"));
    formdata.append(
      "deposit_month",
      dayjs(depositMonth).startOf("month").format("YYYY-MM-DD"),
    );
    if (userId) {
      formdata.append("user_id", userId);
    }
    formdata.append("amount", parseFloat(amount).toFixed(2));
    formdata.append("deposit_status", depositStatus);
    if (bankName) {
      formdata.append("bank_name", bankName);
    }
    if (transactionNo.trim()) {
      formdata.append("transaction_no", transactionNo.trim());
    }
    if (remarks.trim()) {
      formdata.append("remarks", remarks.trim());
    }
    if (file) {
      formdata.append("image", file);
    }

    let response = await handlePutData(
      `/api/v1/deposit/update/${row?._id}`,
      formdata,
      true
    );

    console.log("response", response);
    if (response?.status === 401) {
      logout();
      return;
    }
    if (response.status >= 200 && response.status < 300) {
      setLoading(false);
      handleSnakbarOpen("Updated successfully", "success");
      clearForm();
      if (clearFilter) {
        clearFilter();
      }
      handleDialogClose();
    } else {
      setLoading(false);
      handleSnakbarOpen(
        response?.data?.message || "Error updating deposit",
        "error"
      );
    }
  };

  const customeTextFeild = {
    boxShadow: "0px 1px 2px 0px rgba(15, 22, 36, 0.05)",
    "& .MuiInput-underline:after": {
      borderBottomColor: "#B2BAC2",
    },
    "& .MuiOutlinedInput-input": {},
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "",
      },
      "&:hover fieldset": {
        borderColor: "#969696",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#969696",
      },
    },
  };

  const customeSelectFeild = {
    boxShadow: "0px 1px 2px 0px rgba(15, 22, 36, 0.05)",
    background: "#ffffff",
    "& label.Mui-focused": {
      color: "#E5E5E5",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#B2BAC2",
    },
    "& .MuiOutlinedInput-input": {},
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#",
      },
      "&:hover fieldset": {
        borderColor: "#969696",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#969696",
      },
    },
  };

  const custopDatePickerFeild = {
    boxShadow: "0px 1px 2px 0px rgba(15, 22, 36, 0.05)",
    background: "#ffffff",
    "& .MuiInputBase-root": {
      fontSize: "0.875rem",
      height: "2.5rem",
    },
    "& label.Mui-focused": {
      color: "#E5E5E5",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#B2BAC2",
    },
    "& .MuiOutlinedInput-input": {},
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#",
      },
      "&:hover fieldset": {
        borderColor: "#969696",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#969696",
      },
    },
  };

  const getDropdownList = async () => {
    setLoading2(true);
    let url = `/api/v1/user/dropdownlist`;
    let allData = await getDataWithToken(url);
    if (allData?.status === 401) {
      logout();
      return;
    }
    if (allData.status >= 200 && allData.status < 300) {
      setUserList(allData?.data?.data || []);

      if (allData?.data?.data?.length < 1) {
        handleSnakbarOpen("No users found", "warning");
      }
    } else {
      handleSnakbarOpen(allData?.data?.message, "error");
    }
    setLoading2(false);
  };

  useEffect(() => {
    if (row) {
      setDepositDate(row?.deposit_date ? dayjs(row.deposit_date) : null);
      setDepositMonth(row?.deposit_month ? dayjs(row.deposit_month) : null);
      setUserId(row?.user_id?._id || row?.user_id || "");
      setAmount(row?.amount ? row.amount.toString() : "");
      setBankName(row?.bank_name || "");
      setTransactionNo(row?.transaction_no || "");
      setRemarks(row?.remarks || "");
      if (row?.deposit_status) {
        setDepositStatus(row.deposit_status);
      } else if (row?.status === true) {
        setDepositStatus("complete");
      } else {
        setDepositStatus("pending");
      }
    }
  }, [row]);

  return (
    <>
      <IconButton
        variant="contained"
        disableElevation
        onClick={() => {
          setAddDepositDialog(true);
          getDropdownList();
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          id="Outline"
          viewBox="0 0 24 24"
          width="18"
          height="18"
        >
          <path
            d="M18.656.93,6.464,13.122A4.966,4.966,0,0,0,5,16.657V18a1,1,0,0,0,1,1H7.343a4.966,4.966,0,0,0,3.535-1.464L23.07,5.344a3.125,3.125,0,0,0,0-4.414A3.194,3.194,0,0,0,18.656.93Zm3,3L9.464,16.122A3.02,3.02,0,0,1,7.343,17H7v-.343a3.02,3.02,0,0,1,.878-2.121L20.07,2.344a1.148,1.148,0,0,1,1.586,0A1.123,1.123,0,0,1,21.656,3.93Z"
            fill="#787878"
          />
          <path
            d="M23,8.979a1,1,0,0,0-1,1V15H18a3,3,0,0,0-3,3v4H5a3,3,0,0,1-3-3V5A3,3,0,0,1,5,2h9.042a1,1,0,0,0,0-2H5A5.006,5.006,0,0,0,0,5V19a5.006,5.006,0,0,0,5,5H16.343a4.968,4.968,0,0,0,3.536-1.464l2.656-2.658A4.968,4.968,0,0,0,24,16.343V9.979A1,1,0,0,0,23,8.979ZM18.465,21.122a2.975,2.975,0,0,1-1.465.8V18a1,1,0,0,1,1-1h3.925a3.016,3.016,0,0,1-.8,1.464Z"
            fill="#787878"
          />
        </svg>
      </IconButton>

      <Dialog
        open={addDepositDialog}
        onClose={handleDialogClose}
        sx={{
          "& .MuiPaper-root": {
            borderRadius: "16px",
          },
        }}
        PaperProps={{
          component: "form",
          onSubmit: onSubmit,
        }}
      >
        <DialogTitle
          id="alert-dialog-title"
          sx={{
            fontSize: "20px",
            fontFamily: '"Inter", sans-serif',
            fontWeight: 600,
            color: "#0F1624",
            position: "relative",
            px: 2,
            borderBottom: "1px solid #EAECF1",
          }}
        >
          Update Deposit
          <IconButton
            sx={{ position: "absolute", right: 0, top: 0 }}
            onClick={() => setAddDepositDialog(false)}
          >
            <svg
              width="46"
              height="44"
              viewBox="0 0 46 44"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M29 16L17 28M17 16L29 28"
                stroke="#656E81"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </IconButton>
        </DialogTitle>
        <DialogContent
          sx={{
            maxWidth: "400px",
            minWidth: "400px",
            px: 2,
            borderBottom: "1px solid #EAECF1",
            my: 1,
          }}
        >
          <Typography
            variant="medium"
            color="text.main"
            gutterBottom
            sx={{ fontWeight: 500 }}
          >
            Deposit Date
          </Typography>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              id="depositDate"
              sx={{
                width: "100%",
                ...custopDatePickerFeild,
                mb: 3,
              }}
              format="DD/MM/YYYY"
              maxDate={dayjs()}
              value={depositDate}
              onChange={(newValue) => {
                setDepositDate(newValue);
              }}
            />
          </LocalizationProvider>
          <Typography
            variant="medium"
            color="text.main"
            gutterBottom
            sx={{ fontWeight: 500 }}
          >
            Deposit Month
          </Typography>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              id="depositMonth"
              sx={{
                width: "100%",
                ...custopDatePickerFeild,
                mb: 3,
              }}
              views={["year", "month"]}
              openTo="month"
              format="MMMM YYYY"
              maxDate={dayjs()}
              value={depositMonth}
              onChange={(newValue) => {
                setDepositMonth(newValue);
              }}
            />
          </LocalizationProvider>
          <Typography
            variant="medium"
            color="text.main"
            gutterBottom
            sx={{ fontWeight: 500 }}
          >
            User
          </Typography>
          <FormControl
            fullWidth
            size="small"
            sx={{
              ...customeSelectFeild,
              "& label.Mui-focused": {
                color: "rgba(0,0,0,0)",
              },
              mb: 3,
            }}
          >
            <Select
              id="user_id"
              value={userId}
              onChange={(e) => setUserId(e.target.value)}
              displayEmpty
              MenuProps={{
                PaperProps: {
                  sx: {
                    maxHeight: 250,
                  },
                },
              }}
            >
              <MenuItem value="">Select User (Optional)</MenuItem>
              {userList.map((user) => (
                <MenuItem key={user._id} value={user._id}>
                  {user.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Typography
            variant="medium"
            color="text.main"
            gutterBottom
            sx={{ fontWeight: 500 }}
          >
            Amount
          </Typography>
          <TextField
            required
            type="number"
            size="small"
            fullWidth
            id="amount"
            placeholder="Enter Amount"
            variant="outlined"
            sx={{ ...customeTextFeild, mb: 3 }}
            value={amount}
            onChange={(e) => {
              setAmount(e.target.value);
            }}
            onWheel={(e) => e.target.blur()}
            inputProps={{ min: 0, step: 0.01 }}
          />
          <Typography
            variant="medium"
            color="text.main"
            gutterBottom
            sx={{ fontWeight: 500 }}
          >
            Bank Name
          </Typography>
          <FormControl
            fullWidth
            size="small"
            sx={{
              ...customeSelectFeild,
              "& label.Mui-focused": {
                color: "rgba(0,0,0,0)",
              },
              mb: 3,
            }}
          >
            <Select
              id="bank_name"
              value={bankName}
              onChange={(e) => setBankName(e.target.value)}
              displayEmpty
              MenuProps={{
                PaperProps: {
                  sx: {
                    maxHeight: 250,
                  },
                },
              }}
            >
              <MenuItem value="">Select Bank (Optional)</MenuItem>
              {bangladeshBankList.map((bank) => (
                <MenuItem key={bank} value={bank}>
                  {bank}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Typography
            variant="medium"
            color="text.main"
            gutterBottom
            sx={{ fontWeight: 500 }}
          >
            Transaction Number
          </Typography>
          <TextField
            size="small"
            fullWidth
            id="transaction_no"
            placeholder="Enter Transaction Number (Optional)"
            variant="outlined"
            sx={{ ...customeTextFeild, mb: 3 }}
            value={transactionNo}
            onChange={(e) => {
              setTransactionNo(e.target.value);
            }}
          />
          <Typography
            variant="medium"
            color="text.main"
            gutterBottom
            sx={{ fontWeight: 500 }}
          >
            Remarks
          </Typography>
          <TextField
            size="small"
            fullWidth
            id="remarks"
            placeholder="Enter Remarks (Optional)"
            variant="outlined"
            multiline
            rows={3}
            sx={{ ...customeTextFeild, mb: 3 }}
            value={remarks}
            onChange={(e) => {
              setRemarks(e.target.value);
            }}
          />
          <Typography
            variant="medium"
            color="text.main"
            gutterBottom
            sx={{ fontWeight: 500 }}
          >
            Deposit Status
          </Typography>
          <FormControl
            fullWidth
            size="small"
            sx={{
              ...customeSelectFeild,
              "& label.Mui-focused": {
                color: "rgba(0,0,0,0)",
              },
              "& .MuiOutlinedInput-input img": {
                position: "relative",
                top: "2px",
              },
              mb: 3,
            }}
          >
            <Select
              labelId="demo-simple-select-label"
              id="deposit_status"
              MenuProps={{
                PaperProps: {
                  sx: {
                    maxHeight: 250,
                  },
                },
              }}
              value={depositStatus}
              onChange={(e) => setDepositStatus(e.target.value)}
            >
              {depositStatusList.map((item) => (
                <MenuItem key={item} value={item}>
                  {item.charAt(0).toUpperCase() + item.slice(1)}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Box>
            <ImageUpload
              file={file}
              setFile={setFile}
              dimension="Size: (800 : 600)"
            />
          </Box>
        </DialogContent>

        <DialogActions sx={{ px: 2 }}>
          <Button
            variant="outlined"
            onClick={handleDialogClose}
            sx={{
              px: 2,
              py: 1.25,
              fontSize: "14px",
              fontWeight: 600,
              color: "#344054",
              border: "1px solid #D0D5DD",
              boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
            }}
          >
            Close
          </Button>
          <Button
            variant="contained"
            disabled={loading}
            type="submit"
            sx={{
              px: 2,
              py: 1.25,
              fontSize: "14px",
              fontWeight: 600,
              minWidth: "127px",
              minHeight: "44px",
            }}
            autoFocus
            disableElevation
          >
            <PulseLoader
              color={"#4B46E5"}
              loading={loading}
              size={10}
              speedMultiplier={0.5}
            />{" "}
            {loading === false && "Save changes"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default UpdateDeposit;
